import { useCallback, useState } from "react";
import { createDraftItem, patchDraftItem } from "../services/draft";

type Options = {
  currentUserString: () => string | null;
  draftTtlMs: number;
};

export function useDraftWizard({ currentUserString, draftTtlMs }: Options) {
  const [draftItemId, setDraftItemId] = useState<string | null>(null);
  const [currentStep, setCurrentStep] = useState<number>(1);
  const [entryMode, setEntryMode] = useState<"wizard" | "snabb">("wizard");

  const updateDraftMeta = useCallback(
    async (patch: any) => {
      if (!draftItemId) return;
      try {
        await patchDraftItem(draftItemId, patch);
      } catch (e) {
        console.debug("[Wizard] draft update skipped:", e);
      }
    },
    [draftItemId]
  );

  const ensureDraftItem = useCallback(async (): Promise<string> => {
    if (draftItemId) return draftItemId;

    const id = await createDraftItem(currentUserString(), draftTtlMs);
    setDraftItemId(id);
    return id;
  }, [draftItemId, currentUserString, draftTtlMs]);

  return {
    draftItemId,
    setDraftItemId,
    currentStep,
    setCurrentStep,
    entryMode,
    setEntryMode,
    updateDraftMeta,
    ensureDraftItem,
  };
}
